import ClosePanelBtn from "../ClosePanelBtn/ClosePanelBtn";
import PropTypes, { bool } from 'prop-types'; 

import "../PopUpPanel/PopUpPanel.scss";

const ConfirmationDialog = (props) => {
    return (
        <div className={`blackout popup-panel-holder`}>
            <div className={`popup-panel ${props.className} ${props.wide ? 'wide-popup' : ''}`}>
                {props.showCloseBtn && <ClosePanelBtn clickFunc={props.closePanelFunc} />}
                {props.children}
                <div className="fl-row">
                    <div className="grow"></div>
                    <div className="confirmation-button-holder">
                        <button className="standard-button button-active" onClick={props.confirmFunc}>{props.confirmButtonLabel}</button>
                    </div>
                    <div className="grow"></div>
                    <div className="confirmation-button-holder">
                        <button className="warning-button button-active" onClick={props.cancelFunc}>{props.cancelButtonLabel}</button>
                    </div>
                    <div className="grow"></div>
                </div>
            </div>
        </div>
    );
}

ConfirmationDialog.propTypes = {
    showCloseBtn: PropTypes.bool.isRequired,
    closePanelFunc: PropTypes.func,
    confirmFunc: PropTypes.func.isRequired,
    cancelFunc: PropTypes.func.isRequired,
    className: PropTypes.string,
    wide: PropTypes.bool,
};

ConfirmationDialog.defaultProps = {
    showCloseBtn: true,
    closePanelFunc: null,
    confirmButtonLabel: 'OK',
    cancelButtonLabel: 'Cancel',
    className: '',
    wide: false,
}

export default ConfirmationDialog;
